// this hook doesn't exst in react < v18.0.0
import { useRef } from "react";

let globalIdCounter = 0;

export function useId(prefix = "id"): string {
  const idRef = useRef<string | null>(null);
  if (idRef.current === null) {
    globalIdCounter += 1;
    idRef.current = `${prefix}-${globalIdCounter}`;
  }
  return idRef.current;
}
